import List from 'containers/Orders/List';
import Show from 'containers/Orders/Show';
import OrdersPickingDetail from 'containers/Orders/Show/BatchDetail';

export default { List, Show, OrdersPickingDetail };
